// Shared dark-theme palette for the takeoff surfaces (rebar, civil, review).
// Single source of truth — surface-specific styles.ts files re-export from here.
export const COLORS = {
  bg: '#0D0F1C',
  border: 'rgba(255,255,255,0.06)',
  borderStrong: 'rgba(255,255,255,0.12)',
  text: '#F0F2FF',
  textDim: '#525870',
  textMuted: '#B8BDD6',
  green: '#00E87A',
  greenSoft: 'rgba(0,232,122,0.08)',
  greenBorder: 'rgba(0,232,122,0.3)',
  red: '#FF6B7A',
  redBorder: 'rgba(255,107,122,0.3)',
  amber: '#F0B800',
  amberSoft: 'rgba(240,184,0,0.08)',
  amberBorder: 'rgba(240,184,0,0.35)',
  purple: '#C49BFF',
  accent: '#C49BFF',
  accentSoft: 'rgba(196,155,255,0.08)',
  accentBorder: 'rgba(196,155,255,0.4)',
  rowFocus: 'rgba(196,155,255,0.06)',
  rowFocusBorder: 'rgba(196,155,255,0.4)',
};
